import { optVal, optLabel, LONG_TYPES, SELECT_TYPES } from "@/lib/records";

const box = "w-full px-2.5 py-1.5 rounded border text-sm bg-transparent";

export default function RecordInput({ f, value, onChange }) {
  const tid = `record-input-${f.key}`;
  if (LONG_TYPES.includes(f.type)) {
    const v = f.type === "json" && typeof value === "object" ? JSON.stringify(value, null, 2) : value ?? "";
    return <textarea className={`${box} min-h-[120px] leading-relaxed`} value={v} onChange={(e) => onChange(e.target.value)} data-testid={tid} />;
  }
  if (["multiselect", "multi_select"].includes(f.type)) {
    const cur = Array.isArray(value) ? value : value ? [value] : [];
    return (
      <div className="flex flex-wrap gap-1" data-testid={tid}>
        {(f.options || []).map((o) => {
          const v = optVal(o), on = cur.includes(v);
          return <button type="button" key={String(v)} onClick={() => onChange(on ? cur.filter((x) => x !== v) : [...cur, v])}
            className={`px-2 py-0.5 rounded border text-xs ${on ? "bg-[var(--text)] text-[var(--bg)]" : ""}`}>{optLabel(o)}</button>;
        })}
      </div>
    );
  }
  if (SELECT_TYPES.includes(f.type) || (f.options || []).length) {
    return (
      <select className={box} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={tid}>
        <option value="">—</option>
        {(f.options || []).map((o) => <option key={String(optVal(o))} value={optVal(o)}>{optLabel(o)}</option>)}
      </select>
    );
  }
  if (["checkbox", "boolean"].includes(f.type)) return <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} data-testid={tid} />;
  const type = { number: "number", currency: "number", percent: "number", date: "date", datetime: "datetime-local", email: "email", url: "url", phone: "tel" }[f.type] || "text";
  return <input type={type} className={box} value={value ?? ""} data-testid={tid}
    onChange={(e) => onChange(type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)} />;
}
